import { BehaviorSubject } from "rxjs";

export const Filterchart = new BehaviorSubject("");
export const updateUserList = new BehaviorSubject(0);

export const addTab = new BehaviorSubject({ type: "default" });

export const addClaimsTab = new BehaviorSubject({ type: "default" });
export const addTicketDetailTab = new BehaviorSubject({ type: "default" });
export const TicketTableUpdate = new BehaviorSubject("");